import {ReactElement} from 'react'
import {Autoplay, Controller, Navigation} from 'swiper'
import {Swiper, SwiperRef, SwiperSlide, useSwiper} from 'swiper/react'
import 'swiper/css'
import ProductSliderItem from './../Products/ProductSliderItem'
import ProductThumbnailItem from './../Products/ProductThumbnailItem'
import React from 'react'
interface Props {
  images: any
}
export default function ProductSlider({images}: Props): ReactElement {
  const swiperRef = React.useRef<SwiperRef>(null)

  const [sliderIndex, setSliderIndex] = React.useState(0)
  return (
    <>
      <Swiper slidesPerView={1} modules={[Controller]} ref={swiperRef}>
        {images.reverse().map((image: any, idx: number) => {
          return (
            <SwiperSlide key={idx}>
              <ProductSliderItem image={image} />
            </SwiperSlide>
          )
        })}
      </Swiper>

      <div className="mt-4">
        <Swiper slidesPerView={4} spaceBetween={10}>
          {images.map((image: any, idx: number) => {
            return (
              <SwiperSlide key={idx}>
                <ProductThumbnailItem
                  image={image}
                  index={idx}
                  mainRef={swiperRef}
                  sliderIndex={sliderIndex}
                  setSliderIndex={setSliderIndex}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </>
  )
}
